module.exports = __webpack_public_path__ + "img/GmailLogo.b573e6bc.png";